export type VerzoekTypeKey = 'Definitief' | 'Concept' | 'Idee' | 'SDGverzoek'
export type DoelVerzoekKey = 'Indienen' | 'Aanvullen' | 'Intrekken'

export const verzoekTypeColor: Record<VerzoekTypeKey, 'success' | 'info' | 'warning' | 'default'> = {
  Definitief: 'success',
  Concept: 'info',
  Idee: 'warning',
  SDGverzoek: 'default',
}

export const doelVerzoekColor: Record<DoelVerzoekKey, 'primary' | 'info' | 'error'> = {
  Indienen: 'primary',
  Aanvullen: 'info',
  Intrekken: 'error',
}

export const formatDate = (iso: string): string => {
  try {
    return new Date(iso).toLocaleDateString('nl-NL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  } catch {
    return iso
  }
}
